export default {
  heading: 'BW Vivant Light',
  body: 'Playfair Display, serif',
  monospace: 'Menlo, monospace',
  display: 'Reenie Beanie, cursive',
  googleFonts: ['Playfair Display', 'Reenie Beanie'],
  customFamilies: ['BW Vivant Light'],
  customUrls: ['https://www.gonation.biz/fonts/bw-vivant/bw-vivant.css']
}
